// Shared shell, menu and common words (Arabic). Keyed by the English source text.
export default {
  // Shell + account chrome
  'Log in': 'تسجيل الدخول',
  'Log In': 'تسجيل الدخول',
  'Sign out': 'تسجيل الخروج',
  'Sign Out': 'تسجيل الخروج',
  Account: 'الحساب',
  'Account menu': 'قائمة الحساب',
  Language: 'اللغة',
  'Interface language': 'لغة الواجهة',
  English: 'English',
  Arabic: 'العربية',
  'Coming in Phase 2': 'متاح في المرحلة الثانية',
  More: 'المزيد',
  Home: 'الرئيسية',
  Assets: 'الأصول',
  Scan: 'مسح',
  Orders: 'الطلبات',
  'Toggle navigation': 'تبديل التنقل',
  Close: 'إغلاق',
  'Review billing': 'مراجعة الفواتير',
  'Grand Palm Resort': 'منتجع جراند بالم',
  // Menu
  Administration: 'الإدارة',
  'User Directory': 'دليل المستخدمين',
  'Roles & Permissions': 'الأدوار والصلاحيات',
  Properties: 'العقارات',
  'Locations & Hierarchy': 'المواقع والتسلسل الهرمي',
  'Room Kit Stamping': 'ختم مجموعات الغرف',
  'Assets & Inventory': 'الأصول والمخزون',
  'Master Item Catalogue': 'كتالوج الأصناف الرئيسي',
  'Inwarding & Tagging': 'الاستلام والوسم',
  'Custody & Movements': 'العهدة والحركات',
  Audits: 'عمليات الجرد',
  'Physical Verification': 'التحقق الفعلي',
  'Reconciliation Console': 'وحدة التسوية',
  'Audit Schedules': 'جداول الجرد',
  'Blind Counts & Variance': 'العد الأعمى والفروقات',
  Maintenance: 'الصيانة',
  'Incident Logging': 'تسجيل الحوادث',
  'Work Orders': 'أوامر العمل',
  Accounting: 'المحاسبة',
  'Depreciation Runs': 'تشغيل الإهلاك',
  'Disposals & Write-Offs': 'الاستبعاد والشطب',
  'Plans & Billing': 'الخطط والفوترة',
  Integrations: 'التكاملات',
  Dashboard: 'لوحة المعلومات',
  Locations: 'المواقع',
  'Room Kits': 'مجموعات الغرف',
  Inwarding: 'الاستلام',
  Custody: 'العهدة',
  'Audit Scan': 'مسح الجرد',
  Reconcile: 'تسوية',
  Schedules: 'الجداول',
  'Blind Counts': 'العد الأعمى',
  Incidents: 'الحوادث',
  Depreciation: 'الإهلاك',
  Disposals: 'الاستبعاد',
  Directory: 'الدليل',
  Security: 'الأمان',
  Plans: 'الخطط',
  // Catalogue page
  'Master Item Catalogue & Onboarding Assist': 'كتالوج الأصناف الرئيسي ومساعد التهيئة',
  'Standardized Equipment Catalogue': 'كتالوج المعدات الموحد',
  '7 Mandatory Classes': '7 فئات إلزامية',
  'Search item, SKU, category...': 'ابحث عن صنف أو رمز أو فئة...',
  'All Category Classes': 'كل فئات الأصناف',
  'Export CSV': 'تصدير CSV',
  'Starter Pack': 'الحزمة الأولية',
  'Add Item': 'إضافة صنف',
  'SKU Ref': 'مرجع الصنف',
  'Item Name & Specification': 'اسم الصنف والمواصفات',
  'Category Class': 'فئة الصنف',
  'Tracking Mode': 'نمط التتبع',
  'Standard Cost (AED)': 'التكلفة القياسية (درهم)',
  'Replacement Cost (AED)': 'تكلفة الاستبدال (درهم)',
  'Useful Life': 'العمر الإنتاجي',
  Actions: 'الإجراءات',
  'Loading catalogue...': 'جارٍ تحميل الكتالوج...',
  'No catalogue items match your search.': 'لا توجد أصناف مطابقة لبحثك.',
  'Tagged (Serialized)': 'موسوم (مسلسل)',
  'Pooled (Bulk Count)': 'مجمّع (عد بالجملة)',
  'Edit Catalogue Item': 'تعديل صنف الكتالوج',
  'Add Catalogue Item': 'إضافة صنف إلى الكتالوج',
  'Item Name (Arabic)': 'اسم الصنف بالعربية',
  'Arabic display name (optional)': 'الاسم المعروض بالعربية (اختياري)',
  Cancel: 'إلغاء',
  'Save Item': 'حفظ الصنف',
  'Saving...': 'جارٍ الحفظ...',
  'Merge Duplicates': 'دمج المكررات',
  // Category classes
  'FF&E': 'الأثاث والتجهيزات',
  'Operating Equipment': 'معدات التشغيل',
  'Kitchen & Laundry': 'المطبخ والمغسلة',
  'IT & Telecom': 'التقنية والاتصالات',
  'Plant & Machinery': 'المصانع والآلات',
  Vehicles: 'المركبات',
  Facilities: 'المرافق',
  // Executive dashboard
  'Asset Valuation Hub': 'مركز تقييم الأصول',
  Updated: 'آخر تحديث',
  'No posted run': 'لا يوجد تشغيل مرحَّل',
  'All Properties': 'جميع العقارات',
  'All Departments': 'جميع الأقسام',
  'All Categories': 'جميع الفئات',
  'Property scope': 'نطاق العقار',
  'USALI Department': 'قسم USALI',
  'Valuation & Operations Dashboard': 'لوحة التقييم والعمليات',
  'IAS 16 asset net book values, USALI departmental depreciation, audit compliance, and repair cost trends.': 'صافي القيمة الدفترية للأصول وفق IAS 16، وإهلاك الأقسام وفق USALI، والامتثال للجرد، واتجاهات تكلفة الإصلاح.',
  'Export Summary': 'تصدير الملخص (PDF)',
  'Export to Excel': 'تصدير إلى Excel',
  'Dashboard summary exported as': 'تم تصدير ملخص لوحة المعلومات باسم',
  'Loading...': 'جارٍ التحميل...',
  'Gross Assets': 'إجمالي الأصول',
  'Net Book (NBV)': 'صافي القيمة الدفترية',
  Deprec: 'الإهلاك',
  'Audit Rate': 'نسبة الجرد',
  'Repairs Spend': 'إنفاق الإصلاح',
  assets: 'أصل',
  residual: 'متبقٍّ',
  'active repair records': 'سجل إصلاح نشط',
  Registered: 'مسجَّل',
  'USALI Allocated': 'موزَّع حسب USALI',
  'Xero Posted': 'مرحَّل إلى Xero',
  'Last 12 months': 'آخر 12 شهرًا',
  Manage: 'إدارة',
  'Valuation by Category (AED)': 'التقييم حسب الفئة (درهم)',
  'IAS 16 Base': 'أساس IAS 16',
  'No assets match this scope.': 'لا توجد أصول ضمن هذا النطاق.',
  'USALI Operating Department Allocation': 'توزيع أقسام التشغيل وفق USALI',
  'USALI Operating Department': 'قسم التشغيل وفق USALI',
  'Asset Count': 'عدد الأصول',
  'Cost Basis (AED)': 'أساس التكلفة (درهم)',
  'Period Deprec (AED)': 'إهلاك الفترة (درهم)',
  'Net Book (AED)': 'صافي الدفترية (درهم)',
  'Total Allocated': 'إجمالي الموزَّع',
  'Depreciation Run Trend (IFRS)': 'اتجاه تشغيل الإهلاك (IFRS)',
  'Last 12 posted periods': 'آخر 12 فترة مرحَّلة',
  'No posted Depreciation Run yet.': 'لا يوجد تشغيل إهلاك مرحَّل بعد.',
  'Audit Variance Distribution': 'توزيع فروقات الجرد',
  'audited items': 'بند مجرود',
  Verified: 'مطابق',
  Mislocated: 'في غير موقعه',
  Missing: 'مفقود',
  'Rooms Division': 'قسم الغرف',
  'Food & Beverage': 'الأغذية والمشروبات',
  'Property Operations & Maintenance': 'تشغيل العقار وصيانته',
  'Administrative & General': 'الإدارة والشؤون العامة',
  'Sales & Marketing': 'المبيعات والتسويق',
  // Role labels (config/routeAccess.js ROLE_LABELS)
  "Admin": "المسؤول",
  "Customer Admin": "مسؤول العميل",
  "Property Manager": "مدير العقار",
  "Finance Controller": "المراقب المالي",
  "Auditor (read-only)": "المدقق (قراءة فقط)",
  "Field User": "مستخدم ميداني",
  "Storekeeper": "أمين المخزن",
  "Department Head": "رئيس القسم",
  "User": "مستخدم",
};
